module.exports = __webpack_public_path__ + "static/media/lock_close.96423d79.svg";